import Swiper from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/bundle";

const projectSwipers = function (next) {
	const swiperElements = next.querySelectorAll(".project-slider");

	if (swiperElements.length < 1) return; // didn't find any, exiting...

	let swiperInstances = [];

	let updateBtns = function (swiper) {
		const parent = swiper.el.parentElement;
		const nextBtn = parent.querySelector('.project-slider-button-next')
		const prevBtn = parent.querySelector('.project-slider-button-prev')
		if (swiper.realIndex == swiper.slides.length - 1) {
			nextBtn.classList.add("button-disabled");
		} else {
			nextBtn.classList.remove("button-disabled");
		}
		if (swiper.realIndex == 0) {
			prevBtn.classList.add("button-disabled");
		} else {
			prevBtn.classList.remove("button-disabled");
		}
	}

	swiperElements.forEach((el, index) => {
		let options = {
			navigation: {
				nextEl: ".project-slider-button-next",
				prevEl: ".project-slider-button-prev",
			},
			effect: "cards",
			// grabCursor: true,
			on: {
				init: function (swiper) {
					updateBtns(swiper)
				},
				slideChange: function (swiper) {
					updateBtns(swiper)
				},
			},
		};
		swiperInstances.push(new Swiper(el, options));
	});

	swiperInstances.forEach((swiper) => {
		swiper.on("click", function (swiper, event) {
			swiper.slideNext();
			// console.log("swiper clicked", swiper, event);
		});
	});

	return swiperInstances;
};

export default projectSwipers;
